<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="_id"
      :headers="headers"
      :items="datiFiltrati"
      :options.sync="options"
      :loading="loading || loadingMovimenti"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      dense
    >
<!--     
        :server-items-length="totaleDati"
        :disable-pagination="true"
      :hide-default-footer="true" -->
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          Prodotti non contati per le letture e le categorie scelte
          <v-btn icon @click="getDataFromApi" :loading="loading || loadingMovimenti" title="Aggiorna i dati"><v-icon>mdi-refresh</v-icon></v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
      <v-row dense>     
        <v-col xl="4" md="8" sm="12">
          <v-badge bordered color="error" icon="mdi-refresh" overlap :value="doRefresh" title="I dati sono cambiati! Esegui una nuova verifica">          
            <v-btn @click="getDataFromApi" :loading="loading" :disabled="loading" title="Aggiorna i dati" color="blue-grey" class="white--text">
              Esegui verifica
              <template v-slot:loader>
                <span>Analisi in corso</span>
              </template>
            </v-btn>
          </v-badge>
          <v-btn v-if="totaleDati > 0" class="ml-5" color="success" @click.stop="onToggleSelezione">{{ selected.length === datiFiltrati.length ? 'Annulla selezione' : 'Seleziona tutti' }}</v-btn>
          <v-switch v-model="soloPositivi" inset dense :label="labelSoloPositivi"/>
          <v-switch v-model="contaMovimentati" inset dense label="Considera i prodotti presenti anche se movimentati dalla data"/>
          <v-menu
            v-model="menuMovimentati"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            class="mt-3"
            :disabled="!contaMovimentati"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataMovimentatiFormatted"
                label="Considera movimentati dalla data"
                prepend-inner-icon="mdi-calendar"
                readonly
                :disabled="!contaMovimentati"
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="dataMovimentati = null"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataMovimentati" no-title scrollable @input="menuMovimentati = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col xl="8" md="10" sm="12">
          <v-card>
            <v-card-text>
              <v-row dense>
                <v-col class="d-flex align-center">
                  <v-radio-group v-model="tipoMovimento" dense :disabled="loading || selected.length === 0">
                    <v-radio label="Movimenti di rettifica (consigliato)" value="rettifica"></v-radio>
                    <v-radio label="Movimenti di inventario" value="inventario"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col class="d-flex align-center mt-5">
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    class="mt-3"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDataFormatted"
                        label="Data movimenti e verifica non contati"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="dataMovimenti = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dataMovimenti" no-title scrollable @input="menuStart = false"></v-date-picker>
                  </v-menu>
                </v-col>                   
                <v-col class="d-flex align-center">
                  <v-btn @click="onCreazioneMovimenti" :loading="loadingMovimenti" :disabled="loadingMovimenti || selected.length === 0 || doRefresh" title="Creazione movimenti" color="blue-grey" class="white--text">
                    Crea movimenti
                    <template v-slot:loadingMovimenti>
                      <span>Creazione in corso</span>
                    </template>
                  </v-btn>                  
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      </v-container>
    </template>
    <template v-slot:[`item.acquisto`]="{ item }">
      {{ item.acquisto | euro }}
    </template>
    <template v-slot:[`item.vendita`]="{ item }">
      {{ item.vendita | euro }}
    </template>
    <template v-slot:[`item.valore`]="{ item }">
      {{ item.valore | euro }}
    </template>
    <template v-slot:[`item.file`]="">
    </template>
    <template v-slot:no-data>
      Nessun dato selezionato
    </template>
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma=false"
    />    
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import magazzino from '@/services/magazzinoService'
  import excelService from '@/services/excelService'
  import DialogConferma from '@/components/dialogConferma'  
  import SpeedDial from './speedDial.vue'

  export default {
    components: {
      DialogConferma,
      SpeedDial
    },
    props: {
      reload: Number,
      letture: Array,
      incluse: Object,
      escluse: Object
    },
    data (vm) {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,        
        selected: [],
        loading: false,
        loadingMovimenti: false,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        datiRaw: [],
        // totaleDati: 0,
        intestazioniRaw: [],
        menuStart: false,
        messaggioWarning: false,
        tipoMovimento: 'rettifica', 
        dataMovimenti: moment().utcOffset(0, true).format().substr(0, 10), //  (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dialogConferma: false,
        titoloConferma: '',
        messaggioConferma: '',
        onConferma: vm.onCreazioneMovimenti,
        soloPositivi: true,
        doRefresh: true,
        contaMovimentati: false,
        dataMovimentati: moment().add(-1, 'years').utcOffset(0, true).format().substr(0, 10), 
        menuMovimentati: false,
        numeroPositivi: 0,
        numeroTotali: 0
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      async reload() {
        // await this.getDataFromApi()
      },
      selected(value) {
        this.$emit('selezione', this.selected)
      },
      trigger(value) {

      },
      dataMovimenti (val) {
        this.dataFormatted = this.formatDate(this.dataMovimenti)
      }      
    },
    computed: {
      headers() {
        return this.intestazioniColonneRaw(this.datiRaw)
      },
      computedDataFormatted () {
        return this.formatDate(this.dataMovimenti)
      },
      computedDataMovimentatiFormatted () {
        return this.formatDate(this.dataMovimentati)
      },
      datiFiltrati() {
        return this.soloPositivi ? this.datiRaw.filter(x => x.quantita > 0) : this.datiRaw
      },
      totaleDati() {
        return this.datiFiltrati && this.datiFiltrati.length || 0
      },
      labelSoloPositivi() {
        if (this.numeroTotali > 0) {
          return `Mostra solo quantità positive (${this.numeroPositivi}/${this.numeroTotali})`
        } else {
          return 'Mostra solo quantità positive'
        }
      }
    },
    methods: {
      async onCreazioneMovimenti() {
        this.titoloConferma = "Prodotti non contati"
        let msg = `Confermi creazione movimenti di ${this.tipoMovimento} ?`
        if (this.tipoMovimento === 'rettifica') {
          msg += `<br /><br />Verranno creati movimenti con causale 'Rettifica' e<br />quantità tale da portare la giacenza al valore dell'inventario<br /><br />(Es. giacenza = 5, Inventario = 3 --> Movimento = -2)` 
        } else {
          msg += `<br /><br />Verranno creati movimenti con causale 'Inventario' e<br />quantità uguale  al valore dell'inventario<br /><br />(Es. giacenza = 5, Inventario = 3 --> Movimento = 3)`
          msg += `<br /><br />Questa causale è utile per creare un punto fermo nella giacenza ed eliminare i movimenti precedenti`
        }
        this.messaggioConferma = msg
        this.dialogConferma = true
        this.onConferma = this.creazioneMovimenti
      },
      async creazioneMovimenti() {
        this.dialogConferma = false
        this.loadingMovimenti = true
        for (let s of this.selected) {

          if (!s.quantita) {
            const index = this.selected.indexOf(s)
            this.selected.splice(index, 1)
          }
        }
        // Chiedere conferma + spiegazione tipomovimento
        const magazzinoMovimento = this.$store.getters['magazzini/codiceMagazzino']
        await magazzino.creaMovimentiInventarioNonContati(this.selected, this.tipoMovimento, magazzinoMovimento, this.dataMovimenti, this.letture) // comparazione, tipoMovimento, magazzino, dataMovimento
        this.doRefresh = true
        // await this.getDataFromApi(null, true)
        this.loadingMovimenti = false
      },
      onToggleSelezione() {
        if (this.selected.length === this.datiFiltrati.length) {
          this.annullaSelezione()
        } else {
          this.onAggiungiTutti()
        }
      },
      onAggiungiTutti() {
        this.selected = [...this.datiFiltrati]
      },      
      async getDataFromApi (ev, quiet) {
        try {
          this.doRefresh = false

          if (this.letture.length === 0) return
          this.loading = true
          
          let data = await magazzino.prodottiNonContati(this.letture, this.incluse, this.escluse, this.dataMovimenti, this.contaMovimentati ? this.dataMovimentati : null)
          this.datiRaw = data
          // console.log('dati letti:', data.length)
          // this.totaleDati = data.length
          this.messaggioWarning = (data.filter(x => x.prezzo).length !== data.length) && !quiet

          this.numeroPositivi = data.filter(x => x.quantita > 0).length
          this.numeroTotali = data.length

        } catch(err) {
          this.datiRaw = []
          this.numeroPositivi = 0
          this.numeroTotali = 0
          // this.totaleDati = 0
        } finally {
          this.loading = false
          this.annullaSelezione()
        }
      },
      intestazioniColonneRaw(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        const keys = Object.keys(riga).filter(x => x !== '_id' && x !== 'file')
        const colonne = keys.map(x => {
          return { value: x, text: x.toUpperCase() }
        })
        colonne.push({ text: 'Actions', value: 'actions', sortable: false })
        // colonne.push({ text: '', value: 'data-table-expand' })
        return colonne
      },      
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },     
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'export-riepilogo':
            if (this.datiFiltrati.length > 0) {
              await excelService.creaExcelFromArray(this.datiFiltrati, 'ElencoNonContati.xlsx')
            }
            break      
          default:
            break
        }
      }   
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
